import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Spinner, Col, Row } from 'react-bootstrap';

import useGlobal from '../../store';
import TimbradoComprobanteInfo from './info/TimbradoComprobanteInfo';

const mapState = (store) => {
  return {
    audits: store.developer.stamping.comprobante,
  };
};

const mapActions = (actions) => {
  return { ...actions.developer.stamping.comprobante };
};

const TimbradoComprobantesInfo = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.audits;

  useEffect(() => {
    const { data = {} } = props.location.state || {};
    actions.change(data);

    return () => {
      actions.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const { id } = props.match.params || {};

    if (!!id) {
      actions.info(id);
    } else {
      props.history.replace({
        pathname: `/developers/timbrado/comprobantes`,
      });
    }

    return () => {
      actions.reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-header">
        <Link to="/developers/timbrado/comprobantes">&#8592; Audits</Link>
      </div>

      <h5>
        <Row>
          <Col>
            {!!busy && (
              <Spinner
                animation="border"
                role="status"
                size="sm"
                className="mr-3"
              >
                <span className="sr-only">Recuperando información...</span>
              </Spinner>
            )}
            {data.id || '...'}
          </Col>
        </Row>
      </h5>

      {!!data.idx && (
        <div>
          <div className="d-block mt-3 mb-2">
            <strong className="text-muted">Detalles</strong>
          </div>

          <TimbradoComprobanteInfo data={data} />
        </div>
      )}
    </>
  );
};

export default TimbradoComprobantesInfo;
